<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <!-- BOTÓN DE MENÚ -->
        <!--
        <button
            class="sidebar-toggle mr-2 md:hidden"
            (click)="toggleSidebar('simple-left-sidebar-4')">
            <mat-icon>menu</mat-icon>
        </button>
        -->

        <!-- TÍTULO -->
        <div>
            <span class="text-4xl font-semibold">Administración de Tipo de Instrumento</span>
        </div>
        <div>
            <button
                matTooltip="Refrescar lista"
                class="ml-6 mr-4 text-white px-1 py-1 rounded-md flex items-center gap-1 hover:shadow-2xl transition-all duration-150 ease-in-out hover:-translate-y-1 active:translate-y-0"
                (click)="refreshList()">
                <mat-icon svgIcon="heroicons_outline:refresh"></mat-icon>
            </button>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENIDO PRINCIPAL -->
    <div class="content flex">

        <!-- SIDEBAR -->
        <!--
        <fuse-sidebar class="sidebar" name="simple-left-sidebar-4" position="left" lockedOpen="gt-md">
        -->
        <div class="sidebar p-6 overflow-y-auto">
            <entity-list
                #entityList
                title="Lista de tipo de instrumentos"
                [values]="instrumentsType"
                (entitySelected)="selected($event)">
            </entity-list>
        </div>
        <!-- / SIDEBAR -->

        <!-- DIVISOR -->
        <div class="w-px bg-gray-200"></div>

        <!-- CONTENIDO CENTRAL -->
        <div class="center flex flex-col p-6 flex-grow">

            <!-- TÍTULO -->
            <span class="text-3xl font-semibold mb-4">Datos de Instrumento</span>

            <!-- BOTÓN NUEVO -->
            <div *ngIf="_systemService.canAction('adminClients')" class="pb-4 w-[600px] flex justify-end">
                <button (click)="newInstrumentType()" class="flex items-center gap-2 bg-blue-500 text-white py-2 px-4 rounded">
                    <mat-icon>add</mat-icon>
                    <span>Nuevo</span>
                </button>
            </div>

            <!-- FORMULARIO -->
            <div class="content p-6">
                <app-instrument-type #instrumentForm (entityChanged)="entityChanged($event)"></app-instrument-type>
            </div>

        </div>
        <!-- / CONTENIDO CENTRAL -->

    </div>
    <!-- / CONTENIDO PRINCIPAL -->

</div>



